import React from 'react';
import { Box } from '@mui/material';
import livyConcierge from 'src/img/livy-concierge.svg';
/**
 * Livy, at whatever size the surface draws her. One illustration everywhere: a simplified stand-in
 * for small sizes reads as a second person, which is worse than losing detail.
 *
 * Streaming shows as a ring around the portrait rather than a change of expression, so the same
 * artwork serves both states.
 */
export function LivyAvatar(_ref) {
  let _ref$size = _ref.size,
    size = _ref$size === void 0 ? 26 : _ref$size,
    _ref$thinking = _ref.thinking,
    thinking = _ref$thinking === void 0 ? false : _ref$thinking;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'relative',
      width: size,
      height: size,
      flex: '0 0 auto',
      '@keyframes livyPulse': {
        '0%': {
          transform: 'scale(1)',
          opacity: 0.55
        },
        '70%': {
          transform: 'scale(1.35)',
          opacity: 0
        },
        '100%': {
          transform: 'scale(1.35)',
          opacity: 0
        }
      },
      '@media (prefers-reduced-motion: reduce)': {
        '& [data-motion]': {
          animation: 'none'
        }
      }
    }
  }, thinking && /*#__PURE__*/React.createElement(Box, {
    "data-motion": true,
    "aria-hidden": true,
    sx: {
      position: 'absolute',
      inset: 0,
      borderRadius: '50%',
      border: 2,
      borderColor: 'primary.main',
      animation: 'livyPulse 1.6s ease-out infinite'
    }
  }), /*#__PURE__*/React.createElement(Box, {
    component: "img",
    src: livyConcierge,
    alt: "Livy",
    sx: {
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      display: 'block'
    }
  }));
}